/**
 * @file
 * Behaviors for the Filter Accordion.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Filter Accordion behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.accordion = {
    attach: function() {
      // const accordions = $('.accordion');
      const accordionOpeners = $('.accordion__opener');

      const accordionListener = function(e) {
        let accordionLabel = $(this).attr('title');
        let accordionAction;

        if (!e.target.href) {
          e.stopPropagation();
          const accordionContent = $(this)
            .parent()
            .find('.accordion__content');

          if (
            $(this)
              .parent()
              .hasClass('open')
          ) {
            $(this)
              .parent()
              .removeClass('open');
            $(this)
              .parent()
              .attr('aria-expanded', 'false');
            accordionContent.attr('aria-hidden', 'true');
            accordionContent.stop(true, true).slideUp(300);
            accordionAction = 'close-accordion';
          }
          else if (
            !$(this)
              .parent()
              .hasClass('open')
          ) {
            $(this)
              .parent()
              .addClass('open');
            $(this)
              .parent()
              .attr('aria-expanded', 'true');
            accordionContent.attr('aria-hidden', 'false');
            accordionContent.stop(true, true).slideDown(300);
            accordionAction = 'open-accordion';
          }

          window.gas(
            'send',
            'event',
            'accordion-click',
            accordionAction,
            accordionLabel
          );
        }
      };
      for (let i = 0; i < accordionOpeners.length; i++) {
        accordionOpeners.eq(i).on('click', accordionListener);
      }

      // 508 compliance, allowing the Enter key to open accordions
      $(document).on('keyup', (e) => {
        let target = $(e.target);
        if (e.keyCode === 13 && target.hasClass('accordion__question')) {
          e.preventDefault();
          e.stopPropagation();
          target.click();
        }
      });
    }
  };
})(Drupal, jQuery);
